/* ============================================================
   I LIBRI CURIOSI · scheda degli ebook (31/10/2026)
   Caricato solo da sections/libricuriosi-ebook.liquid. Galleria e carrello
   restano in libricuriosi.js; qui solo le carte da provare del «Quiz dei
   perché» (snippets/lc-ebook-quiz.liquid): si tocca una risposta, la giusta
   diventa verde, quella sbagliata rossa, e compare la spiegazione.
   Senza script la spiegazione resta visibile (classe lc-ek-pronto).
   ============================================================ */
(() => {
  'use strict';
  document.querySelectorAll('[data-lc-ek-quiz]').forEach(carta => {
    const giusta = carta.dataset.giusta;
    const bottoni = Array.from(carta.querySelectorAll('[data-r]'));
    const esito = carta.querySelector('[data-lc-ek-esito]');
    carta.classList.add('lc-ek-pronto');
    bottoni.forEach(b => b.addEventListener('click', () => {
      if (carta.classList.contains('lc-ek-fatto')) return;
      carta.classList.add('lc-ek-fatto');
      bottoni.forEach(x => {
        x.setAttribute('aria-disabled', 'true');
        if (x.dataset.r === giusta) x.classList.add('lc-ek-si');
      });
      const bene = b.dataset.r === giusta;
      if (!bene) b.classList.add('lc-ek-no');
      b.setAttribute('aria-pressed', 'true');
      if (esito) esito.textContent = bene ? 'Giusto!' : 'Era la ' + giusta + '.';
    }));
  });
})();
